import { render, staticRenderFns } from "./CollegeRegistrationForm.vue?vue&type=template&id=c859ccb4&scoped=true&"
import script from "./CollegeRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./CollegeRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./CollegeRegistrationForm.vue?vue&type=style&index=0&id=c859ccb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c859ccb4",
  null
  
)

export default component.exports